import { type FC } from 'react';

import Typography from '@mui/material/Typography';
import { MEDIUM_FONT_SIZE } from 'modules/map/components/pdf-print-form/utils';

interface StyleTableHeadCellTextProps {
  label: JSX.Element;
  sx?: React.CSSProperties;
}

const StyleTableHeadCellText: FC<StyleTableHeadCellTextProps> = ({ label, sx }) => (
  <Typography
    sx={{
      fontSize: MEDIUM_FONT_SIZE,
      fontWeight: 600,
      ...sx,
    }}
  >
    {label}
  </Typography>
);

export default StyleTableHeadCellText;
